export const makeEstimatesList = (response) => {
    const estimatesList = [{ title: i18next.t('makeEstimatesList.notPicked.text'), value: null }];

    response.data.forEach((estimate) => {
        const optionParent = {
            value: estimate.id,
            title: estimate.name,
            isHead: true,
            children: [],
        };

        estimatesList.push(optionParent);
        estimate.estimate_list.forEach((listItem) => {
            const option = {
                value: listItem.guid,
                title: listItem.name,
                parent: estimate.id,
                isPadding: true,
            };
            estimatesList.push(option);
            optionParent.children.push(option);
        });
    });

    return estimatesList;
};
